// extracted by mini-css-extract-plugin
export default {"plan-wrapper":"Plan_plan-wrapper__cuFFk","title-wrapper":"Plan_title-wrapper__5OjxM","plan-info-list":"Plan_plan-info-list__w39+S","button":"Plan_button__oCBXP"};